<template>
  <div class="detail-quiz">
    <div class="header is-flex">
      <div class="logo">
        <a href="/training-v1">
          <img src="/img/onboard-driver/Logo_AhaDriver.svg" alt />
        </a>
      </div>
      <div class="vertical"></div>
      <div class="title">
        <p>Đào tạo trực tuyến</p>
      </div>
    </div>
    <div class="section">
      <div class="center-section">
        <router-view></router-view>
      </div>
    </div>
  </div>
  <!-- <router-view></router-view> -->
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.detail-quiz {
  .header {
    height: 80px;
    width: 100%;
    align-items: center;
    padding-left: 40px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

    .vertical {
      width: 1px;
      height: 20px;
      background-color: #c4c4c4;
      height: 40px;
      margin: 0 30px;
    }
    .title {
      p {
        font-size: 18px;
        color: #074f80;
      }
    }
  }
  .section {
    background-color: #f2f4f8;
    .center-section {
      max-width: 860px;
      margin: 0 auto;
    }
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  .detail-quiz {
    .header {
      display: none !important; 
    }
    .section {
      padding: 0;
    }
  }
}
</style>